// @ts-nocheck
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import {filter} from "rxjs/operators";
import {loadScript} from "./utilities/util";
import {environment} from "../environments/environment";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {languages} from "./language-manager/language";
import type Language from "./language-manager/lang-manager/language.model";
import { MatSortModule } from '@angular/material/sort';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {NgStyle} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {AlertDialogComponent} from "./shared/dialogs/alert-dialog/alert-dialog.component";
import {interval} from "rxjs";
import {ifStmt} from "@angular/compiler";
import {b} from "@angular/core/navigation_types.d-u4EOrrdZ";

declare global {
  interface Window {
    zE: (..._) => void;
    zESettings: any;
    dataLayer: any;
    mapsLoaded: boolean;
    L: any;
    loc: GeolocationPosition,
    countries: any [];
  }
}

window.dataLayer = window.dataLayer || [];

function gtag(..._) { window.dataLayer.push(arguments) }

const svgs = [
  {name: 'completed', path: '/ct/svg/completed.svg'},
  {name: 'empty', path: '/ct/svg/empty.svg'},
]

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>
    <div mat-sort-header="name" matSort class="hidden"></div>
    @if(showInternetStatus) {
      <div class='internet-status'
         [ngStyle]="{backgroundColor: internetStatus ? '#00d400': '#f74949'}">
      {{(internetStatus ? 'main.online' : 'main.offline') | translate}}
    </div>
    }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, MatSortModule, NgStyle, TranslatePipe]
})
export class AppComponent implements OnInit{
  private router = inject(Router);
  private translateService = inject(TranslateService);
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  private dialog = inject(MatDialog);


  private readonly storageLang = 'storageKey';
  readonly languages = languages;

  internetStatus = true;
  showInternetStatus = false;
  timeoutId: any;
  appStartTime = new Date();
  isCargoCube: boolean;

  constructor() {

    this.isCargoCube = window.location.href.includes('cargo-cube');
    const isIos = /(iPad|iPhone|iPod)/g.test( navigator.userAgent ) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

    if(isIos) {
      document.body.classList.add('is-ios')
    }

    if(!this.isCargoCube) {
      loadScript('https://www.googletagmanager.com/gtag/js?id=UA-118371648-6', true, true, () => {
        gtag('js', new Date());
        gtag('config', 'UA-118371648-6');
      });
    }

    this.addGoogleMapsScript();

    //register svgs
    svgs.forEach(e => this.iconRegistry.addSvgIcon(e.name, this.sanitizer.bypassSecurityTrustResourceUrl(e.path)))

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => gtag('page_path', event.urlAfterRedirects));

    this.internetStatus = window.navigator.onLine;

    window.addEventListener('online', () => {
      this.internetChangeFn(true);
    });
    window.addEventListener('offline', () => {
      this.internetChangeFn(false);
    });
    //this.appVersionUpdatesChecker();
  }

  internetChangeFn(internetStatus: boolean) {
    this.internetStatus = internetStatus;
    this.showInternetStatus = true;
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.showInternetStatus = false, 3000);
  }

  askUpdateDialog() {
    this.dialog.open(AlertDialogComponent, {
      data: {
        title: 'main.new-version',
        secondTitle: 'main.new-version.desc'
      }
    }).afterClosed().subscribe(res => {
      if(res) location.reload();
    })
  }

  // appVersionUpdatesChecker() {
  //   if(this.updates.isEnabled) {
  //     interval(60 * 60 * 1000).subscribe(async () => {
  //       try {
  //         const updateFound = await updates.checkForUpdate();
  //         console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
  //       } catch (err) {
  //         console.error('Failed to check for updates:', err);
  //       }
  //     })
  //   }
  //
  //   this.updates.versionUpdates.subscribe(evt => {
  //     switch (evt.type) {
  //       case 'VERSION_DETECTED':
  //         console.log(`Downloading new app version: ${evt.version.hash}`);
  //         break;
  //       case 'VERSION_READY':
  //         const timePassedSeconds = Math.round((new Date() - this.appStartTime) / 1000);
  //         if((60 * 30) < timePassedSeconds) {//only update after 30 min
  //           this.askUpdateDialog();
  //         }
  //
  //         console.log(`Current app version: ${evt.currentVersion.hash}`);
  //         console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
  //         break;
  //       case 'VERSION_INSTALLATION_FAILED':
  //         console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
  //         break;
  //     }
  //   });
  // }

  async addGoogleMapsScript() {
    let language = 'en';
    if(this.isCargoCube) {
      const paramLang = new URLSearchParams(window.location.search).get('lang');
      if (paramLang != null && paramLang.trim()) {
        language = paramLang;
      }
    }

    (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
      key: environment.google.key,
      v: "weekly",
      language: language
      // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
      // Add other bootstrap parameters as needed, using camel case.
    });
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
  }


  ngOnInit() {
    this.initLanguageManagement();
  }

  initLanguageManagement() {
    this.translateService.addLangs(['en', 'sq', 'de', 'it', 'es', 'ru']);
    const browserLang = this.translateService.getBrowserLang();

    const savedLang = JSON.parse(localStorage.getItem(this.storageLang) || null);

    //fallback language
    this.translateService.setFallbackLang('en');

    const lang = savedLang || this.languages.find(e => e.code === browserLang) || {name: 'English', code: 'en', flag: 'us.png'};
    this.setLanguage(lang);
  }

  setLanguage(lang: Language) {
    this.translateService.use(lang.code);
    localStorage.setItem(this.storageLang, JSON.stringify(lang));
  }

}
